import PropTypes from "prop-types";

import styles from "./styles.module.css";

const LoaderContractModalWrapper = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

LoaderContractModalWrapper.propTypes = {
  children: PropTypes.node,
};

export default LoaderContractModalWrapper;
